import { useClassStore } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { computed } from 'mobx';

import { InitialiseAPI } from '~gateways/initialise';
import container from '~ioc/ioc';
import { AnalyticsStore } from '~stores/analytics';
import AuthStore from '~stores/authentication';
import { FloorsListStore } from '~stores/floors-list';

@injectable()
class AppPresenter {
  @inject(AuthStore) private _authStore!: AuthStore;
  @inject(FloorsListStore) private _floorsStore2!: FloorsListStore;
  @inject(AnalyticsStore) private _analyticsStore!: AnalyticsStore;

  @computed get isReady(): boolean {
    return this._floorsStore2.isReady.value;
  }

  logAppInit = () => {
    const userId = this._authStore.currentUser?.id;
    this._analyticsStore.logAppStart({ userId });
    InitialiseAPI.initialise().then();
  };

  initApp = async () => {
    await Promise.allSettled([
      this._floorsStore2.fetch(),
      this._authStore.authCheck(),
    ]);

    this.logAppInit();
  };
}

export const useAppPresenter = () =>
  useClassStore<AppPresenter>(container.get(AppPresenter));
